import { Accordion, Col, Nav, Row, Tab } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { DynamicHtml } from "@/ui/DynamicHtml";
import classes from "./styles.module.scss";
import clsx from "classnames";
import ArrowRight from "@/assets/ArrowRight.svg";
import { useMediaQuery } from "@react-hook/media-query";
import { useEffect, useState } from "react";

export const MiniTabs = ({ className, items, variant, id }) => {
  const breakpoint = useMediaQuery("only screen and (min-width: 1200px)");
  const [isMobile, setMobile] = useState(null);

  useEffect(() => {
    setMobile(!breakpoint);
  }, [breakpoint]);

  return (
    <div className={clsx(className, classes.tabs, `variant-${variant}`)}>
      {isMobile ? (
        items.map((i, k) => (
          <Accordion id={`${id}_${k}`} key={k} className="mx-md-5">
            <Accordion.Item eventKey={k}>
              <Accordion.Header>
                <DynamicText path={i.title.path} />
                <i className="flex-shrink-0">
                  <ArrowRight />
                </i>
              </Accordion.Header>
              <Accordion.Body className="mt-3">
                <DynamicHtml path={i.text.path} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ))
      ) : (
        <Tab.Container>
          <Row>
            <Col xs={12} sm={6} className="px-sm-0">
              <Nav variant="pills" className="flex-column">
                {items.map((i, k) => (
                  <Nav.Item key={k}>
                    <Nav.Link eventKey={k} className="p-3">
                      <DynamicText path={i.title.path} />
                      <i>
                        <ArrowRight />
                      </i>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
            <Col xs={12} sm={6} className="px-sm-0">
              <Tab.Content>
                {items.map((i, k) => (
                  <Tab.Pane key={k} eventKey={k}>
                    <DynamicHtml path={i.text.path} className="p-4" />
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      )}
    </div>
  );
};

MiniTabs.defaultProps = {
  id: "miniTabs",
  className: "",
  items: [],
  variant: "primary",
};
